import Swiper from 'swiper';
import { A11y, Pagination } from 'swiper/modules';

const contextual = document.querySelector('.contextual-publications .swiper-container') !== null;

if (contextual) {

    let config = {

        modules: [ A11y, Pagination ],

        spaceBetween: 30,
        watchOverflow: true, // default
    
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    
        a11y: {
            enabled: true,
            firstSlideMessage: "C'est la première diapositive",
            lastSlideMessage: "C'est la dernière diapositive",
            paginationBulletMessage: 'Aller à la diapositive {{index}}',
        },
    }
    
    let swiper = new Swiper('.contextual-publications .swiper-container', config);
}
